var XMLFile = require("../xml/XMLFile");

/**
 * This class represents the [Content_Types].xml within the generated Excel.
 *
 * @constructor
 */
function ContentTypes() {
	XMLFile.call(this, ContentTypes.metadata);
}

ContentTypes.prototype = Object.create(XMLFile.prototype);
ContentTypes.prototype.constructor = ContentTypes;


ContentTypes.FILENAME = "";
ContentTypes.metadata = {
	filename: "[Content_Types].xml",
	tag: "Types",
	root: true,
	attributes: [
		{
			name: "xmlns",
			value: "http://schemas.openxmlformats.org/package/2006/content-types"
		}
	],
	properties: [
		{
			tag: "Default",
			attributes: [
				{
					name: "Extension",
					value: "xml"
				},
				{
					name: "ContentType",
					value: "application/xml"
				}
			]
		},
		{
			tag: "Default",
			attributes: [
				{
					name: "Extension",
					value: "rels"
				},
				{
					name: "ContentType",
					value: "application/vnd.openxmlformats-package.relationships+xml"
				}
			]
		},
		{
			tag: "Override",
			attributes: [
				{
					name: "PartName",
					value: "/xl/workbook.xml"
				},
				{
					name: "ContentType",
					value: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml"
				}
			]
		},
		{
			tag: "Override",
			attributes: [
				{
					name: "PartName",
					value: "/xl/worksheets/sheet1.xml"
				},
				{
					name: "ContentType",
					value: "application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml"
				}
			]
		},
		{
			tag: "Override",
			attributes: [
				{
					name: "PartName",
					value: "/xl/styles.xml"
				},
				{
					name: "ContentType",
					value: "application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml"
				}
			]
		},
		{
			tag: "Override",
			attributes: [
				{
					name: "PartName",
					value: "/xl/sharedStrings.xml"
				},
				{
					name: "ContentType",
					value: "application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml"
				}
			]
		},
		{
			tag: "Override",
			attributes: [
				{
					name: "PartName",
					value: "/docProps/core.xml"
				},
				{
					name: "ContentType",
					value: "application/vnd.openxmlformats-package.core-properties+xml"
				}
			]
		},
		{
			tag: "Override",
			attributes: [
				{
					name: "PartName",
					value: "/docProps/app.xml"
				},
				{
					name: "ContentType",
					value: "application/vnd.openxmlformats-officedocument.extended-properties+xml"
				}
			]
		}
	]
};

module.exports = ContentTypes;